export default "__VITE_ASSET__BtWT$0wO__"